module.exports = {"version":"6f401bb5e3e54c5d88cba4292d79d8401f31a4c2"}


//////////////////
// WEBPACK FOOTER
// ./src/build.json
// module id = 3060
// module chunks = 0